<style src='./style.scss'>

</style>

<article class="mbsc-row">
  <header class="mbsc-col-12">
    <h1>Contáctanos</h1>
    <p class="mbsc-col-12 mbsc-col-lg-8">¿Tienes alguna duda, pregunta o felicitación?, no dudes en contactarnos.</p>
  </header>
  <section class="mbsc-col-12">
    <div class="mbsc-form-grid contact-form">
      <div class="mbsc-grid">
        <div class="mbsc-row mbsc-justify-content-center">
          <div class="mbsc-col-sm-9 mbsc-col-md-7 mbsc-col-xl-5">
            <div class="mbsc-note mbsc-note-primary mbsc-align-center">{message}</div>
            <div class="mbsc-note mbsc-note-warning mbsc-align-center">{message}</div>
          </div>
        </div>
        <div class="mbsc-row mbsc-justify-content-center">
          <div class="mbsc-col-12 mbsc-col-lg-6">
            <label>
              Nombre
              <input required id="name" name="name" mbsc-input data-input-style="box" data-label-style="floating" placeholder="¿Cuál es tu nombre?" />
            </label>
          </div>
        </div>
        <div class="mbsc-row mbsc-justify-content-center">
          <div class="mbsc-col-12 mbsc-col-md-6">
            <label>
              Correo Electrónico
              <input required id="email" name="email" mbsc-input data-input-style="box" data-label-style="floating" type="text" placeholder="Introduce tu correo electrónico" />
            </label>
          </div>
        </div>
        <div class="mbsc-row mbsc-justify-content-center">
          <div class="mbsc-col-12 mbsc-col-md-6">
            <label>
              <select mbsc-dropdown id="topic" name="topic">
                <option>Elige una opción</option>
                <option value="pago">Pagos</option>
                <option value="soporte">Soporte Técnico</option>
                <option value="membresias">Membresías</option>
                <option value="otro">Otro</option>
              </select>
            </label>
          </div>
        </div>
        <div class="mbsc-row mbsc-justify-content-center">
          <div class="mbsc-col-12 mbsc-col-md-6">
            <label>
              Mensaje
              <textarea id="message" name="message" required mbsc-input data-input-style="box" data-label-style="floating" placeholder="Dejanos información sobre tu perfil para que podamos contactarte."></textarea>
            </label>
          </div>
        </div>
        <div class="mbsc-row mbsc-justify-content-center">
          <div class="mbsc-col-12 mbsc-col-md-6">
            <div class="mbsc-btn-group-block">
              <button 
                class="mbsc-btn-success" on:click={sendContact}>Enviar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</article>

<script>
  import { onMount, afterUpdate } from 'svelte';
  import { Utils, Email, AWSAnalytics } from '@Services';

  const DEBUG = document.location.protocol === 'http:' ? true : false;

  let message = '';

  let sendContact = () => {
    grecaptcha.ready(function() {
      grecaptcha.execute('6LdBTfoUAAAAABe7RjOADF37tt4jTyBZi-hXijLZ', {action: 'submit'}).then(function(token) {
        document.querySelector('.mbsc-note-warning').style.display = 'none';
        document.querySelector('.mbsc-note-primary').style.display = 'none';

        if (document.querySelector('#name').value && document.querySelector('#email').value && document.querySelector('#message').value && (document.querySelector('#topic').selectedIndex > 0)) {
          if (!Email.validateEmail(document.querySelector('#email').value)) {
            message = 'Hubo un error al enviar tu mensaje, verifica que los datos sean correctos.';
            document.querySelector('.mbsc-note-warning').style.display = 'block';
            return false;
          }
          let formData = {
            name: document.querySelector('#name').value,
            email: document.querySelector('#email').value,
            topic: document.querySelector('#topic').value,
            message: document.querySelector('#message').value,
          }
          Email.sendContact(formData).then(response => {
            message = 'Tu correo ha sido enviado correctamente, en breve nos pondremos en contacto contigo.';
            document.querySelector('.mbsc-note-primary').style.display = 'block';
            document.querySelector('#name').value = null;
            document.querySelector('#email').value = null;
            document.querySelector('#message').value = null;
            document.querySelector('#topic').selectedIndex = 0;
          }).catch(error => {
            message = 'Tu correo ha sido enviado, en breve nos pondremos en contacto contigo.';
            document.querySelector('.mbsc-note-primary').style.display = 'block';
            document.querySelector('#name').value = null;
            document.querySelector('#email').value = null;
            document.querySelector('#message').value = null;
            document.querySelector('#topic').selectedIndex = 0;
          });
        }else{
          message = 'Hubo un error al enviar tu mensaje, verifica que hayas llenado todos los campos.';
          document.querySelector('.mbsc-note-warning').style.display = 'block';
        }
      }).catch(error => {
        console.error(error)
      });
    });
  };

  onMount(async () =>{
    mobiscroll.form('.contact-form', {})

    Utils.scrollToTop();
  });
</script>
